export function underScoreSpaces(text: string) {
  // replace symbols that can't be used in an object key with alternate values
  // if the text starts with a number, prepend an underscore
  const prepended = text?.match(/^\d/) ? `_${text}` : text;
  return prepended?.replace(/[^a-zA-Z0-9]/g, '_');
}
